// extracted by mini-css-extract-plugin
export default {"title":"ChangePasswordPage_title__irUBv","content":"ChangePasswordPage_content__Geepk"};